import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Icon from "@insite/mobius/Icon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import SliderTabLeft from "@ucs/Icons/SliderTabLeft";
import SliderTabRight from "@ucs/Icons/SliderTabRight";
import React, { MouseEventHandler } from "react";

export interface EmblaButton {
    enabled: boolean;
    onClick: MouseEventHandler<HTMLButtonElement>;
    styles: ButtonPresentationProps;
}

export const PrevButton = ({ enabled, onClick, styles }: EmblaButton) => (
    <Button onClick={onClick} disabled={!enabled} {...styles}>
        <Icon src={SliderTabLeft} size={28}></Icon>
    </Button>
);

export const NextButton = ({ enabled, onClick, styles }: EmblaButton) => (
    <Button onClick={onClick} disabled={!enabled} {...styles}>
        <Icon src={SliderTabRight} size={28}></Icon>
    </Button>
);
